
var latinize = require('./latinize');
var decode = require('html-entities').Html5Entities.decode;

module.exports = function(str) {
  if (typeof str === 'string') {
    str = latinize(decode(str.toLowerCase()));
    str = str.replace(/-/g, ' ');
    str = str.replace(/[^a-z0-9 ]+/gi, '');
    str = str.trim().replace(/ /g, '-');
    str = str.replace(/[-]{2}/g, '');
    return str;
  } else {
    return str;
  }
};




// WEBPACK FOOTER //
// ./client/src/app/utils/slugify.js